export const ArchWindow = ({ size = 40, className = "", bar = "#FFFFFF" }) => (
  <div
    className={`arch-shape relative overflow-hidden ${className}`}
    style={{
      width: size,
      height: size * 1.45,
      background: "linear-gradient(135deg, #E84C4C 0%, #F3A0A0 55%, #FAD0C4 100%)",
      boxShadow: "0 0 24px rgba(232,76,76,0.45)",
    }}
  >
    <div className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2" style={{ width: Math.max(2, size * 0.08), backgroundColor: bar }} />
    <div className="absolute left-0 right-0" style={{ height: Math.max(2, size * 0.08), top: "38%", backgroundColor: bar }} />
  </div>
);
